const cityArr = [
    {
        id: '21987653',
        address: 'Бугульма, Респ. Татарстан, Красноармейская ул., 66а',
        phone: ['+7 (992) 000-42-62', '+7 (967) 780-08-01'],
        mail: 'gpdom@inbox.ru',
    },
    {
        id: '219876533',
        address: 'Набережные Челны, Мензелинский тракт, 31',
        phone: ['+7 (917) 87 01 116'],
        mail: 'ritual116@list.ru',
    },
    {
        id: '123345',
        address: 'Казань, Респ. Татарстан, Мамадышский тракт, 179 похоронный комплекс Курган',
        phone: [],
        mail: null,
    },
]

//Ужасный костыль с подменой адреса города

function citiAddress (id, arr) {
    let city = arr.find(el => el.id === id)
    if (city) {
        //Находим в топе инфу и подменяем ее
        const address = document.querySelector('.header-info__icon_street');
        address.textContent = city.address;

        //Удаляем текущие телефоны
        const phones = document.querySelectorAll('.header-info__icon_tel');
        for (let phone of phones) {
            phone.remove();
        };
        if(city.phone.length > 0) {
            for (let elementPhone of city.phone) {
                address.insertAdjacentHTML('afterend',
                    `<a href="tel:${elementPhone}" class="header-info__item header-info__icon header-info__icon_tel">
                        ${elementPhone}
                    </a>`
                )
            };
        }

        // Подмена телефона
        const mail = document.querySelector('.header-info__icon_mail');
        if(city.mail === null) {
            mail.remove();
        }
        mail.textContent = city.mail;

        //Подмена на странице контакты
        const contactsRow = document.querySelector('.contacts__js');
        if(contactsRow) {
            contactsRow.remove();
        }
        const contacts = document.querySelector('.contacts__row');
        if(contacts) {
            contacts.insertAdjacentHTML('afterbegin',
                `
                    <span class="contacts__item">${city.address}</span>
                `
            )
        }

        const contactsPhone = document.querySelector('.contacts__item');
        if(contactsPhone) {
            if(city.phone.length > 0) {
                for (let elementPhone of city.phone) {
                    contactsPhone.insertAdjacentHTML('afterend',
                        `
                            <a class="contacts__link" href="tel:${elementPhone}">Телефон: ${elementPhone}</a>
                        `
                    )
                };
            }
        }

        if(city.mail !== null && contacts) {
            contacts.insertAdjacentHTML('beforeend', `
                <a class="contacts__link" href="mailto:${city.mail}">${city.mail}</a>
                `
            )

        }

        const mapsJs = document.querySelector('.block-vw');
        if(mapsJs) {
            mapsJs.remove();
        }


        //Заблокировать на главной фильтр
        const filterBloker = document.querySelector('.filter-container');
        if(filterBloker) {
            filterBloker.classList.add('blokerFilter');
        }
        const filterJsBloker = document.querySelector('.filter-count');
        if(filterJsBloker) {
            filterJsBloker.insertAdjacentHTML('beforeend', `
                <div class="blokerJsFilter" >База в текущий момент наполняется, просьба перейти на страницу <a href="https://ritual-archive.ru/contacts-page">контакты</a>, для связи с организацией</div>
                `
            )
        }

        const input = document.querySelectorAll('.input-js');

        for (let inputElement of input) {
            inputElement.disabled = true;
        };

        if(filterJsBloker) {
            filterJsBloker.insertAdjacentHTML('beforeend', `
                <div class="blokerJsFilterOpacity" ></div>
                `
            )
        }
        
        // function init () {
        //     var myMap = new ymaps.Map("map", {
        //             center: [55.76, 37.64],
        //             zoom: 5
        //         }, {
        //             searchControlProvider: 'yandex#search'
        //         }),
        //         myPlacemark = new ymaps.Placemark([55.907228, 31.260503], {
        //             // Чтобы балун и хинт открывались на метке, необходимо задать ей определенные свойства.
        //             balloonContentHeader: "Балун метки",
        //             balloonContentBody: "Содержимое <em>балуна</em> метки",
        //             balloonContentFooter: "Подвал",
        //             hintContent: "Хинт метки"
        //         });
        //
        //     myMap.geoObjects.add(myPlacemark);
        //
        //     // Открываем балун на карте (без привязки к геообъекту).
        //     myMap.balloon.open([55.76, 37.64], "Содержимое балуна", {
        //         // Опция: не показываем кнопку закрытия.
        //         closeButton: false
        //     });
        // }
        //
        // ymaps.ready(init);

    }
}

citiAddress(getCookie('region'), cityArr);